import { Component, OnDestroy } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-gift-card-image-selection',
  templateUrl: './gift-card-image-selection.component.html',
  styleUrls: ['./gift-card-image-selection.component.less'],
})
export class GiftCardImageSelectionComponent implements OnDestroy {
  private unsub: Subject<void> = new Subject<void>();
  photoFormControl = new FormControl(null, Validators.required);

  constructor(private activeModal: NgbActiveModal) {}

  closeModal() {
    this.activeModal.dismiss();
  }

  onFileChange(event: Event) {
    const file = (event.target as HTMLInputElement).files[0];
    this.photoFormControl.setValue(file);
  }

  async onSubmit() {
    const file = this.photoFormControl.value as File;
    this.activeModal.close(file);
  }

  ngOnDestroy(): void {
    this.unsub.next();
    this.unsub.complete();
  }
}
